//#region src/logger.ts
const loggedMessages = new Set();
const logger = {
	warnOnce: (msg) => {
		if (loggedMessages.has(msg)) return;
		loggedMessages.add(msg);
		console.warn(msg);
	},
	logOnce: (msg) => {
		if (loggedMessages.has(msg)) return;
		console.log(msg);
		loggedMessages.add(msg);
	}
};

//#endregion
export { logger };
//# sourceMappingURL=logger-DmtxRp_g.mjs.map